import React, { useState, useRef, useEffect } from 'react';

export default function UpperBar({ rfcs, onSelect }) {
    const [query, setQuery] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const itemRefs = useRef([]);

    if (!rfcs) rfcs = [];

    const filtered = rfcs.filter(rfc => {
        const id = rfc.data.id.toLowerCase();
        const title = (rfc.data.title || "").toLowerCase();
        const authors = (Array.isArray(rfc.data.authors) ? rfc.data.authors.join(" ") : "").toLowerCase();
        const q = query.toLowerCase();
        return id.includes(q) || title.includes(q) || authors.includes(q);
    });

    // Reset active index when results change
    useEffect(() => { setActiveIndex(0); }, [query]);

    // Scroll highlighted item into view
    useEffect(() => {
        if (itemRefs.current[activeIndex]) {
            itemRefs.current[activeIndex].scrollIntoView({ block: 'nearest' });
        }
    }, [activeIndex]);

    const select = (rfc) => { onSelect(rfc); setQuery(""); };

    const handleKeyDown = (e) => {
        if (!query) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActiveIndex(i => Math.min(i + 1, filtered.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActiveIndex(i => Math.max(i - 1, 0));
        } else if (e.key === 'Enter' && filtered.length > 0) {
            select(filtered[activeIndex]);
        } else if (e.key === 'Escape') {
            setQuery("");
        }
    };

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <div style={{
                width: "100%", height: "60px", borderBottom: "1px solid #ccc",
                padding: "10px", display: "flex", alignItems: "center", gap: "20px",
                background: "#f7f7f7", position: "sticky", top: 0, zIndex: 10
            }}>
                <h3 style={{ margin: 0 }}>RFCs</h3>
                <input
                    type="text"
                    placeholder="Search RFC…"
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                    style={{
                        padding: "6px 10px", fontSize: "14px", width: "250px",
                        borderRadius: "4px", border: "1px solid #aaa"
                    }}
                />
            </div>

            {query.length > 0 && (
                <div style={{
                    position: "absolute", top: "60px", left: "10px", width: "300px",
                    maxHeight: "300px", overflowY: "auto", background: "white",
                    border: "1px solid #ccc", borderRadius: "4px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)", zIndex: 9999
                }}>
                    {filtered.length === 0 && (
                        <div style={{ padding: "10px", color: "#777" }}>No matches</div>
                    )}
                    {filtered.map((rfc, i) => (
                        <div
                            key={rfc.data.id}
                            ref={el => itemRefs.current[i] = el}
                            style={{
                                padding: "8px 12px", cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                background: i === activeIndex ? "#e8f0fe" : "white"
                            }}
                            onMouseEnter={() => setActiveIndex(i)}
                            onClick={() => select(rfc)}
                        >
                            <strong>{rfc.data.id}</strong>
                            <br />
                            <span style={{ fontSize: "12px", color: "#555" }}>
                                {rfc.data.title || ""}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
